/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count words, characters, sentences and paragraphs in your text, with reading time and keyword density — updated live as you type.`)
};

const es_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta palabras, caracteres, oraciones y párrafos en tu texto, con tiempo de lectura y densidad de palabras clave — actualizado en vivo mientras escribes.`)
};

const de_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählen Sie Wörter, Zeichen, Sätze und Absätze in Ihrem Text mit Lesezeit und Schlüsselwortdichte – wird live aktualisiert, während Sie eingeben.`)
};

const nl_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel woorden, tekens, zinnen en alinea's in uw tekst, met leestijd en trefwoorddichtheid — live bijgewerkt terwijl u typt.`)
};

const fr_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez les mots, les caractères, les phrases et les paragraphes de votre texte, avec le temps de lecture et la densité des mots-clés — mise à jour en direct en tapant.`)
};

const it_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta parole, caratteri, frasi e paragrafi nel tuo testo, con tempo di lettura e densità di parole chiave — aggiornati in tempo reale mentre digiti.`)
};

const pt_br2_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte palavras, caracteres, frases e parágrafos em seu texto, com tempo de leitura e densidade de palavras-chave — atualizado ao vivo enquanto você digita.`)
};

const pt_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte palavras, caracteres, frases e parágrafos no seu texto, com tempo de leitura e densidade de palavras-chave — actualizados em direto conforme escreve.`)
};

const ja_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの単語、文字、文、段落をカウント。読む時間とキーワード密度も表示。入力中にリアルタイムで更新されます。`)
};

const zh_wc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计文本中的字数、字符数、句子数和段落数，并提供阅读时间和关键词密度——输入时实时更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_intro", locale)
	if (locale === "en") return en_wc_intro(inputs)
	if (locale === "es") return es_wc_intro(inputs)
	if (locale === "de") return de_wc_intro(inputs)
	if (locale === "nl") return nl_wc_intro(inputs)
	if (locale === "fr") return fr_wc_intro(inputs)
	if (locale === "it") return it_wc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_wc_intro(inputs)
	if (locale === "pt") return pt_wc_intro(inputs)
	if (locale === "ja") return ja_wc_intro(inputs)
	return zh_wc_intro(inputs)
};